import { render, staticRenderFns } from "./LanguagesTranslationsHome.vue?vue&type=template&id=20c28f83&scoped=true&"
import script from "./LanguagesTranslationsHome.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c28f83",
  null
  
)

export default component.exports